import BackToCampaignLink from '../components/BackToCampaignLink';
import useGetBackToCampaignParams from './useGetBackToCampaignParams';
import { useEmbeddedEditorContext } from '../embedded/EmbeddedEditorContext';
export default function useBackToCampaign() {
  const {
    fromCampaignId,
    fromStudioCampaignId
  } = useGetBackToCampaignParams();
  const {
    isInsideMarketingStudio
  } = useEmbeddedEditorContext();
  return {
    shouldDisplayBackToCampaign: !!(fromCampaignId || fromStudioCampaignId) || isInsideMarketingStudio,
    BackToCampaignComponent: BackToCampaignLink
  };
}